import { render, staticRenderFns } from "./newForm.vue?vue&type=template&id=5e8d400b&scoped=true&"
import script from "./newForm.vue?vue&type=script&lang=js&"
export * from "./newForm.vue?vue&type=script&lang=js&"
import style0 from "./newForm.vue?vue&type=style&index=0&id=5e8d400b&scoped=true&lang=css&"
import style1 from "./newForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8d400b",
  null
  
)

export default component.exports